import React from 'react';
import styles from './LayoutWrapper.module.sass';

const LayoutWrapper = ({ children }) => {
    return <div className={styles['layoutwrapper']}>
        { children }
    </div>;
}

export default LayoutWrapper;